export default function moderationAttachments() {
  return {
    destroyConfirmationMessage: 'Are you sure?',

    init() {
      const msg = this.$root.getAttribute('data-destroy-confirmation-message');
      if (msg) this.destroyConfirmationMessage = msg;
    },

    submitAttachments() {
      this.$refs.form.requestSubmit();
    },

    removeAttachment(blobId) {
      if (window.confirm(this.destroyConfirmationMessage)) {
        this.$refs.form.querySelector(`input[data-moderation-attachment-hidden-input='${blobId}']`).remove();
        this.$root.querySelector(`[data-moderation-attachment-link-tag='${blobId}']`).classList.add('hidden');
        this.submitAttachments();
      }
    },
  };
}
